module.exports = __webpack_public_path__ + "img/賴清德.9887579e.png";